var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-attachments col-grow-1 wrapper-lg",class:_vm.classes},[_c('task-attach',{attrs:{"task":_vm.task}}),_c('task-attachments-files',{attrs:{"task":_vm.task}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }